export { default } from './SeccioNoticiesEclipsi';
